import { render, staticRenderFns } from "./admin-purshase-product-info-edit.vue?vue&type=template&id=0e5f8c21"
import script from "./admin-purshase-product-info-edit.vue?vue&type=script&lang=js"
export * from "./admin-purshase-product-info-edit.vue?vue&type=script&lang=js"
import style0 from "./admin-purshase-product-info-edit.vue?vue&type=style&index=0&id=0e5f8c21&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports